import { AnalyticsLinkerValue } from "../../models/analytics-linker-value.model";

export function bool(source: string | boolean): boolean {
    return source === true || source == "1" || source === "true";
}

export function boolOrDefault(source: string | boolean, defaultValue: boolean): boolean {
    if (typeof (source) !== "undefined" && source != null)
        return source === true || source == "1" || source === "true";
    return defaultValue;
}

export function int(source: string|number): number {
    const parsed = parseInt(source.toString(), 10);
    if (isNaN(parsed)) throw `${source} is not a number`;
    return parsed;
}

export function intOrDefault(source: string|number, defaultValue?: any): number {
    const parsed = parseInt(source.toString(), 10);
    return isNaN(parsed) ? defaultValue || 0 : parsed;
}

export function arrayOrDefault(array: any) {
    if (!array) return [];
    if (Array.isArray(array)) return array;
    if (Array.isArray(array.item)) return array.item;
    if (Array.isArray(array.datum)) return array.datum;
    return [array];
};

export function fromRadix64(val: string) {
    if (val == null || !val.length) return val;
    // URL Safe Radix64 to standard Base64
    var unclean = val
        .replace(/_/g, '/')
        .replace(/-/g, '+');

    // Base64 => Hex string
    var hex = atob(unclean)
        .split('')
        .map(function(x) {
            return x.charCodeAt(0).toString(16).padStart(2, '0');
        })
        .join('');

    // Handle GUID and numeric types
    return hex.length === 32
        ? hex.substring(0, 8) + '-' + hex.substring(8, 12) + '-' + hex.substring(12, 16) + '-' + hex.substring(16, 20) + '-' + hex.substring(20) // GUID
        : parseInt(hex, 16); // Decimal
}



export function toRadix64(val: string | number) {
    if (val == null) return val;
    // Handle GUID, hexadecimal and numeric types
    let str = isNaN(val as number)
        ? (val as string).replace(/-/g, '') // GUID/Hex
        : val.toString(16) // Decimal    
    if (!str.length) return val;

    // Ensure hex is even length
    if (str.length % 2 === 1) {
        str = '0' + str;
    }

    // Convert to hex string
    const hex = str
        .match(/(.{2})/g)!
        .map((x) => String.fromCharCode(parseInt(x, 16)))
        .join('');

    // Encode as URL-safe radix64
    return btoa(hex)
        .replace(/\//g, '_')
        .replace(/\+/g, '-')
        .replace(/=/g, '');
}

export function decodeLinkerValues(str: string): AnalyticsLinkerValue | undefined {
    const parts = str?.split('.');
    if (!parts?.length) {
        return undefined;
    }

    // Check expiry timestamp
    const timestamp = fromRadix64(parts[0]) as number;

    // Invalid timestamp, more than 5 minutes old or a "timestamp" in the future due to corruption
    const currentTime = Date.now() / 1000;
    if (isNaN(timestamp) || currentTime > (timestamp + 600) || currentTime < (timestamp - 10)) {
        return undefined;
    }

    return {
        timestamp: timestamp,
        visitorType: fromRadix64(parts[1]) as number,
        componentType: fromRadix64(parts[2]) as number,
        interactionType: fromRadix64(parts[3]) as number,
        expiration: fromRadix64(parts[4]) as number,
        clientId: fromRadix64(parts[5]) as string,
        planId: fromRadix64(parts[6]) as string,
        experimentType: parts[7],
        propertyCode: parts[8],
        groupId: parts[9]
    };
}
